import { ComponentChildren } from 'preact';
import type { States, LinkRendererContext, DiagramLinkData } from './diagram.types';
import { DiagramLinkElement } from './DiagramLinkElement';
import { layerStyles } from './themes/DiagramStyles.css';

type Props<K2, K1, D2> = {
  links: D2[];
  states: States<K1, K2>;
  previousStates: States<K1, K2>;
  linkRenderer: (context: LinkRendererContext<D2>) => ComponentChildren;
  width: number;
  height: number;
  supportsSelection: boolean;
};

export function DiagramLinkLayer<
  K2,
  K1,
  D2 extends DiagramLinkData<K2, K1> = DiagramLinkData<K2, K1>
>({
  links,
  states,
  previousStates,
  linkRenderer,
  width,
  height,
  supportsSelection
}: Props<K2, K1, D2>) {
  return (
    <svg class={layerStyles} width={width} height={height}>
      {links.map((link) => {
        const state = {
          selected: states.selectedLinkIds.includes(link.id),
          focused: states.focusedId === link.id,
          hovered: states.hoveredId === link.id,
          zoom: states.zoom
        };
        const previousState = {
          selected: previousStates.selectedLinkIds.includes(link.id),
          focused: previousStates.focusedId === link.id,
          hovered: previousStates.hoveredId === link.id,
          zoom: previousStates.zoom
        };
        return (
          <DiagramLinkElement
            id={link.id}
            label={link.label}
            state={state}
            previousState={previousState}
            isDimmed={
              states.highlightedIds.length !== 0 && !states.highlightedIds.includes(link.id)
            }
            activeId={states.activeId}
            accessibleLabel={link.accessibleLabel}
            data={link}
            linkRenderer={linkRenderer}
            supportsSelection={supportsSelection}
          />
        );
      })}
    </svg>
  );
}
